import { createAsyncThunk } from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import { showAppLoader, hideAppLoader  } from '../../Shared/Loader/LoaderSlice';
import authenticationProvider from '../../../utilities/authentication/authenticationProvider';
import { goToPage, setRouterDisplay, setErrorPage, setServiceNumber, setSelectRadio, reportDWH } from './ServiceAppointmentBlockSlice';
import { buildUrlAndOpenWindow } from '../../../utilities/StringHelpers/StringHelpers';

import {openWorkOrderForServiceAppointment}     from '../../../utilities/openWorkOrder';
import EpiContext from '@episerver/spa-core/Spa';
import Config from 'app/Config';

export const routerActivationWizardInitiateAsync = createAsyncThunk('serviceAppointmentSchedulerBlock/routerActivationWizardInitiateAsync', async (data, thunkAPI) => {
    try {
        const result = await ProviderManager.getProviderData('routerActivationWizardInitiate', data);
        return result?.Body;
    } catch (error) {
        thunkAPI.dispatch(goToPage({ page: 'errorPage', typePage: 'GENERAL_ERROR' }));
    }
});

export const routerActivationWizardGetStepAsync = createAsyncThunk('serviceAppointmentSchedulerBlock/routerActivationWizardGetStepAsync', async (data, thunkAPI) => {
    try {
        const result = await ProviderManager.getProviderData('routerActivationWizardGetStep', data);
        return result?.Body;
    } catch (error) {
        thunkAPI.dispatch(goToPage({ page: 'errorPage', typePage: 'GENERAL_ERROR' }));
    }
});

const getServiceErrorNumber = (serviceNumber, thunkAPI) => {
    const pageMapping = {
        '451.700': { page: 'errorPage', typePage: 'ACTION_CANNOT_BE_PERFORMED_THIS_TIME_3' },
        '451.701': { page: 'errorPage', typePage: 'CANNOT_CONNECT_FIBER_013_PAGE_4' },
        '451.702': { page: 'errorPage', typePage: 'REGIONAL_ISSUE_PAGE_5_2' },
        '451.703': { page: 'errorPage', typePage: 'CONTACT_FOR_SUPPORT_6' },
        '451.704': { page: 'errorPage', typePage: 'CONTACT_FOR_SUPPORT_6' },
        '451.706': { page: 'messagePage', typePage: 'RESTARTING_THE_ROUTER_8_1' },
        '451.705': { page: 'messagePage', typePage: 'RESTART_NO_CELLCOM_8_2' },
        '451.709': { page: 'errorPage', typePage: 'CONNECTION_NOT_CORRECT' },//For go to technicianPage
        '451.710': { page: 'restartRouter', typePage: 'STRENGTH_PERFORMED_9_2' },
        '451.707': { page: 'serviceRequestMainPage', typePage: 'LIGHTS_TURN_ON_LIKE_PICTURE_8_1_2' },
        '451.708': { page: 'messagePage', typePage: 'RESTARTING_THE_ROUTER_ONCE_AGAIN_8_1_4' },
        '451.711': { page: 'progressBar', typePage: 'RESET_COMMUNICATION_BEZEQ_9_2_1' },
        '451.712': { page: 'progressBar', typePage: '1/2_RESETTING_IS_PROGRESS_9_2_2' },
        '451.713': { page: 'progressBar', typePage: '2/2_RESETTING_IS_PROGRESS_9_2_2' },
        '451.714': { page: 'errorPage', typePage: 'CONNECTION_FIXED_NOT_CORRECT_9_2_3' },
        '451.715': { page: 'errorPage', typePage: 'SUPPORT_FURTHER_ASSISTANCE' },
        '451.000': { page: 'serviceRequestMainPage', typePage: 'PERFORMED_TESTS_CONNECTION' }
    };

    if(serviceNumber === '451.000'){
      thunkAPI.dispatch(createMemoAsync({memoType: 'AV63'})); //'הלקוח השלים בדיקה באשף ולא נמצאה תקלת חוסר סנכרון'
    }

    if(serviceNumber === '451.721'){
        thunkAPI.dispatch(reportDWH({ actionType: 'InternetFaultWizard Page', status: 'Completed', messageText: 'InternetFaultWizard Finished', param1: 'Power Supply Failure', param2: 'מצאנו שיש בעיה בספק כוח ויש להחליף אותו' }));
        thunkAPI.dispatch(createMemoAsync({memoType: 'AVA1'})); //'הלקוח זכאי לספק כוח חדש'
        thunkAPI.dispatch( goToPage({ page: 'serviceRequestMainPage', typePage: 'SELECT_DELIVERY_POWER_SUPPLY' }));
        return
    }

    return pageMapping[serviceNumber] ? thunkAPI.dispatch(goToPage(pageMapping[serviceNumber])) : thunkAPI.dispatch(goToPage({ page: 'errorPage', typePage: 'GENERAL_ERROR' }));
};


const checkNumberError = async (guid, thunkAPI, notShowAppLoader) => {
    try {
        if (!notShowAppLoader) thunkAPI.dispatch(showAppLoader());

        const state = thunkAPI.getState().serviceAppointmentSchedulerBlock;
        const request = { requestId: guid, blockId: state.dataEpi.blockId, stepId: state.stepId };

        return await thunkAPI.dispatch(routerActivationWizardGetStepAsync(request));
    } catch (error) {
        console.error(error);
    } finally {
        thunkAPI.dispatch(hideAppLoader());
    }
};


export const goToNextPageAsync = createAsyncThunk('serviceAppointmentSchedulerBlock/goToNextPageAsync', async (data, thunkAPI) => {
    try {
        let serviceAppointmentScheduler = thunkAPI.getState().serviceAppointmentSchedulerBlock;
        let page = serviceAppointmentScheduler.page;
        let router = serviceAppointmentScheduler.dataEpi.routerList?.filter((item) => {
            return serviceAppointmentScheduler.subscriber?.equipments?.some((x) => x.productId === item.id);
        });
        thunkAPI.dispatch(setRouterDisplay(router));
        let numberError;
        let namePage ;

        const isEmpty = (obj) => {
            return Object.keys(obj).length === 0;
        };

        switch (page) {
            case 'messagePage':
                switch (serviceAppointmentScheduler.typePage) {
                    case 'PERFORMING_INTERNET_TEST_PAGE_1_1_1_1':
                        if (serviceAppointmentScheduler.subscriber.hasDebt || serviceAppointmentScheduler.subscriber.hasPaymentMethodIssue) {
                          thunkAPI.dispatch(goToPage( { page: 'errorPage', typePage: 'ACTION_CANNOT_BE_COMPLETED_PAGE_2_1' }));
                        } else {
                            thunkAPI.dispatch(showAppLoader());
                            const requestBan = {
                                ban: serviceAppointmentScheduler.subscriber.ban,
                                blockId: serviceAppointmentScheduler.dataEpi.blockId
                            };
                            const initiateResult = await thunkAPI.dispatch(routerActivationWizardInitiateAsync(requestBan));
                            getServiceErrorNumber(initiateResult.payload.outputCode, thunkAPI);
                            if (initiateResult.payload.outputCode === '451.703' ||
                                initiateResult.payload.outputCode === '451.704' ||
                                initiateResult.payload.outputCode === '451.700' ||
                                initiateResult.payload.outputCode === '451.701' ||
                                initiateResult.payload.outputCode === '451.702' ||
                                initiateResult.payload.outputCode === '451.715'
                            ){
                                thunkAPI.dispatch(reportDWH({ actionType: 'InternetFaultWizard Page', status: 'Completed', messageText: 'Service needed' }));
                            };
                        };
                        break;
                    case 'RESTARTING_THE_ROUTER_8_1':
                        numberError = await checkNumberError(serviceAppointmentScheduler.guid,thunkAPI);
                        getServiceErrorNumber( numberError.payload.outputCode, thunkAPI);
                        break;
                    case 'RESTARTING_THE_ROUTER_ONCE_AGAIN_8_1_4':
                        numberError = await checkNumberError(serviceAppointmentScheduler.guid,thunkAPI);
                        getServiceErrorNumber( numberError.payload.outputCode, thunkAPI);
                        break;
                    case 'RESTART_NO_CELLCOM_8_2':
                        thunkAPI.dispatch( goToPage({ page: 'serviceRequestMainPage', typePage: 'LIGHTS_TURN_ON_LIKE_PICTURE_8_1_2' }));
                        break;
                    case 'RECEIVED_11_1_1':
                        EpiContext.navigateTo(Config.lobbyUrl);
                        break;
                    };
                break;
            case 'subscribersPage':
                if(isEmpty(serviceAppointmentScheduler.subscriber)){
                    thunkAPI.dispatch( goToPage({ page: 'errorPage', typePage: 'NO_INTERNET_SERVICE_PAGE' }));
                }else{
                    thunkAPI.dispatch( goToPage({ page: 'messagePage', typePage: 'PERFORMING_INTERNET_TEST_PAGE_1_1_1_1' }));
                };
                break;
            case 'serviceRequestMainPage':
                thunkAPI.dispatch(setSelectRadio(data));
                switch (serviceAppointmentScheduler.typePage){
                    case 'NO_INTERNET_CONNECTION_1_1_1':
                        switch (data) {
                          case 'appliances_in_the_house_are_not_working' :
                            thunkAPI.dispatch(goToPage( { page: 'messagePage', typePage: 'PERFORMING_INTERNET_TEST_PAGE_1_1_1_1' }));
                          break;
                          case 'some_devices_have_an_internet_connection' :
                            thunkAPI.dispatch( goToPage({ page: 'serviceRequestMainPage', typePage: 'INTERNET_CONNECTION_TYPE_1_1_1_2' }));
                          break;
                      }
                        break;
                    case 'YOUR_INTERNET_STATUS_1_1':
                        switch (data) {
                            case 'no_internet' :
                                thunkAPI.dispatch( goToPage({ page: 'serviceRequestMainPage', typePage: 'NO_INTERNET_CONNECTION_1_1_1' }));
                            break;
                            case 'internet_connection_is_slow' :
                                thunkAPI.dispatch(goToPage( { page: 'serviceRequestMainPage', typePage: 'INTERNET_CONNECTION_TYPE_1_1_2' }));
                            break;
                            case 'disconnections_in_the_connection' :
                                thunkAPI.dispatch( goToPage({ page: 'serviceRequestMainPage', typePage: 'INTERNET_CONNECTION_TYPE_1_1_3' }));
                            break;
                        }
                        break;
                    case 'INTERNET_CONNECTION_TYPE_1_1_1_2':
                        switch (data){
                            case 'wifi_connection':
                                buildUrlAndOpenWindow(serviceAppointmentScheduler.dataEpi.linkConnectionFailureWifi.url);
                                break
                            case 'wired_connection':
                                buildUrlAndOpenWindow(serviceAppointmentScheduler.dataEpi.linkConnectionFailureLine.url);
                                break
                        }
                        break;
                    case 'INTERNET_CONNECTION_TYPE_1_1_2':
                        switch (data){
                            case 'wifi_connection':
                                buildUrlAndOpenWindow(serviceAppointmentScheduler.dataEpi.linkSlowConnectionWifi.url);
                                break
                            case 'wired_connection':
                                buildUrlAndOpenWindow(serviceAppointmentScheduler.dataEpi.linkSlowConnectionLine.url);
                                break
                        }
                        break;
                    case 'INTERNET_CONNECTION_TYPE_1_1_3':
                        switch (data){
                            case 'wifi_connection':
                                buildUrlAndOpenWindow(serviceAppointmentScheduler.dataEpi.linkConnectionDisconnectionGuidWifi.url);
                                break
                            case 'wired_connection':
                                buildUrlAndOpenWindow(serviceAppointmentScheduler.dataEpi.linkConnectionDisconnectionGuidLine.url);
                                break
                        }
                        break;
                    case 'LIGHTS_TURN_ON_LIKE_PICTURE_8_1_2':
                        switch (data){
                            case 'shown_as_in_the_picture':
                                const numberError = await checkNumberError(serviceAppointmentScheduler.guid,thunkAPI);
                                getServiceErrorNumber( numberError.payload.outputCode, thunkAPI);
                            break
                            case 'lights_turned_on_differently':
                                thunkAPI.dispatch(goToPage( { page: 'restartRouter', typePage: 'EXTENDING_ROUTER_TIME_8_1_3' }));
                            break
                            case 'lights_didnt_turn_on':
                                thunkAPI.dispatch( goToPage({ page: 'restartRouter', typePage: 'EXTENDING_ROUTER_TIME_8_1_3' }));
                            break
                        }
                      break;
                    case 'LIGHTS_TURN_ON_LIKE_PICTURE_8_1_3':
                        switch (data){
                            case 'shown_as_in_the_picture':
                            thunkAPI.dispatch( goToPage({ page: 'messagePage', typePage: 'RESTARTING_THE_ROUTER_ONCE_AGAIN_8_1_4' }));
                            break
                            case 'lights_turned_on_differently':
                            thunkAPI.dispatch( goToPage({ page: 'messagePage', typePage: 'RESTARTING_THE_ROUTER_ONCE_AGAIN_8_1_4' }));
                            break
                            case 'lights_didnt_turn_on':
                            thunkAPI.dispatch( goToPage({ page: 'errorPage', typePage: 'ROUTER_IS_PLUGGED_8_3' }));
                            thunkAPI.dispatch(reportDWH({ actionType: 'InternetFaultWizard Page', status: 'Completed', messageText: 'InternetFaultWizard Finished', param1: 'Service needed' }));
                            break
                        };
                        break;
                        case 'LIGHTS_TURN_ON_LIKE_PICTURE_8_1_4':
                            switch (data){
                                case 'shown_as_in_the_picture':
                                    getServiceErrorNumber('710', thunkAPI)
                                break
                                case 'lights_turned_on_differently':
                                    //loop
                                    thunkAPI.dispatch( goToPage({ page: 'messagePage', typePage: 'RESTARTING_THE_ROUTER_ONCE_AGAIN_8_1_4' }));
                                break
                                case 'lights_didnt_turn_on':
                                        //loop
                                        thunkAPI.dispatch( goToPage({ page: 'messagePage', typePage: 'RESTARTING_THE_ROUTER_ONCE_AGAIN_8_1_4' }));
                                break
                              };
                          break;
                          case 'PERFORMED_TESTS_CONNECTION':
                            switch (data){
                                case 'you_can_surf_the_internet':
                                    thunkAPI.dispatch( goToPage({ page: 'messagePage', typePage: 'HAPPY_TO_HELP' }));
                                    thunkAPI.dispatch(reportDWH({ actionType: 'InternetFaultWizard Page', status: 'Completed', messageText: 'InternetFaultWizard Finished', param1: 'Inernet Works Correctly' }));
                                    break
                                case 'you_still_cant_surf':
                                    thunkAPI.dispatch( goToPage({ page: 'serviceRequestMainPage', typePage: 'INTERNET_CONNECTION_TYPE_1_1_1_2' }));
                                    thunkAPI.dispatch(reportDWH({ actionType: 'Error Screen', status: 'Error', messageText: 'General Error', param1: 'InternetFaultWizard' }));
                                break
                              };
                            break;
                          case 'SELECT_DELIVERY_POWER_SUPPLY':
                          switch (data){
                              case 'pickup':
                                  EpiContext.navigateTo(serviceAppointmentScheduler.dataEpi.linkCollectionPoints.url);
                                  break
                              case 'delivery':
                                  thunkAPI.dispatch( goToPage({ page: 'addressPage', typePage: 'DELIVERY_POWER_SUPPLY' }));
                              break
                            };
                          break;
                        };
                break;
            case 'technicianPage':
                await thunkAPI.dispatch(setTimeSlotAsync());
                break;
            case 'technicianSuccessPage':
                EpiContext.navigateTo(Config.lobbyUrl);
                break;
            case 'restartRouter':
                switch (serviceAppointmentScheduler.typePage) {
                    case 'RESET_ROUTER_8_1_1':
                        numberError = await checkNumberError(serviceAppointmentScheduler.guid, thunkAPI);
                        getServiceErrorNumber(numberError.payload.outputCode, thunkAPI);
                        break;
                    case 'EXTENDING_ROUTER_TIME_8_1_3':
                        thunkAPI.dispatch(goToPage( { page: 'serviceRequestMainPage', typePage: 'LIGHTS_TURN_ON_LIKE_PICTURE_8_1_3' }));
                        break;
                    case 'STRENGTH_PERFORMED_9_2':
                        numberError = await checkNumberError(serviceAppointmentScheduler.guid, thunkAPI);
                        getServiceErrorNumber(numberError.payload.outputCode, thunkAPI);
                        break;
                }
                break;
            case 'progressBar' :
                switch (serviceAppointmentScheduler.typePage){
                    case 'RESET_COMMUNICATION_BEZEQ_9_2_1':

                        numberError = await checkNumberError(serviceAppointmentScheduler.guid, thunkAPI);
                        getServiceErrorNumber(numberError.payload.outputCode, thunkAPI)
                    break;
                    case '1/2_RESETTING_IS_PROGRESS_9_2_2':
                         numberError = await checkNumberError(serviceAppointmentScheduler.guid, thunkAPI, true);
                        getServiceErrorNumber(numberError.payload.outputCode, thunkAPI)

                    break;
                    case '2/2_RESETTING_IS_PROGRESS_9_2_2':
                        numberError = await checkNumberError(serviceAppointmentScheduler.guid, thunkAPI);
                        getServiceErrorNumber(numberError.payload.outputCode, thunkAPI);
                    break;
                };
                break;
            case 'addressPage' :
                switch (serviceAppointmentScheduler.typePage){
                    case 'DELIVERY_POWER_SUPPLY':
                      await thunkAPI.dispatch(getDeliverySlotsAsync());
                      thunkAPI.dispatch( goToPage({ page: 'deliveryPage', typePage: null }));
                }
              break;
            case 'deliveryPage' :
                await thunkAPI.dispatch(createDeliveryOrderAsync());
              break;
        };
    } catch (error) {
        console.error(error);
    } finally {
        thunkAPI.dispatch(hideAppLoader());
    }
});

export const createMemoAsync = createAsyncThunk('serviceAppointmentSchedulerBlock/createMemoAsync', async (data, thunkAPI) => {
    try {

        const state = thunkAPI.getState().serviceAppointmentSchedulerBlock;
        const selectedSubscriber = state.subscriber;
        const ban = selectedSubscriber?.ban;
        const subscriberNumber = selectedSubscriber?.subscriberNo;

        const params = {
            externalIdNum: ban,
            externalIdType: 'B',
            memoType: data.memoType,
            memoManualTxt: '' ,// טקסט הערה נשלח מהג'ט לפי הקוד הערה
            memoBan: ban,
            memoSubscriber: subscriberNumber

        };
       ProviderManager.getProviderData('createMemo', params);
    }
    catch {

    } finally {

    }
});

export const doCallBack = createAsyncThunk('serviceAppointmentSchedulerBlock/doCallBack', async (data, thunkAPI) => {
    try {
        thunkAPI.dispatch(showAppLoader());
        const state = thunkAPI.getState().serviceAppointmentSchedulerBlock;
        const authentication = thunkAPI.getState().authentication;

        const response = await ProviderManager.getProviderData('doCallBack', [authentication.loginData.userDetails.IDNumber, state.phoneNumberForCallBack, state.dataEpi.subjectCode]);
        if(response.Body.isSuccess){
            thunkAPI.dispatch(reportDWH({ actionType: 'CallBack', status: 'Completed', messageText: 'CallBack Added to Queue' }));
            thunkAPI.dispatch(goToPage({ page: 'messagePage', typePage: 'RECEIVED_11_1_1' }));
            thunkAPI.dispatch(createMemoAsync({memoType: 'AV62'})); //'הלקוח פתח בהצלחה CB'
        }else{
            thunkAPI.dispatch(reportDWH({ actionType: 'Error Screen', status: 'Error', messageText: 'General Error', param1: 'CallBack' }));
        }
        return response;
    } catch (error) {
        console.error(error);
    } finally {
        thunkAPI.dispatch(hideAppLoader());
    }
});

export const getTimeSlotsAsync = createAsyncThunk('serviceAppointmentSchedulerBlock/getTimeSlotsAsync', async (data, thunkAPI) => {
    try {
        thunkAPI.dispatch(showAppLoader());
        const state = thunkAPI.getState().serviceAppointmentSchedulerBlock;
        const selectedSubscriber = state.subscriber;

        const request = {
            ban: selectedSubscriber?.ban,
            consumerId: selectedSubscriber?.consumerId,
            address: {
                cityCode: selectedSubscriber?.address?.cityCode,
                streetCode: selectedSubscriber?.address?.streetCode,
                infrastructure: selectedSubscriber?.address?.infrastructure,
            }
        }

        const response = await ProviderManager.getProviderData('getWizardTechTimeslots', request);
        if(response?.Body.successResult.isSuccess){
            if(response?.Body?.hasServiceVisit){
                thunkAPI.dispatch( goToPage({ page: 'errorPage', typePage: 'TECHNICIAN_COORDINATED_12_2' }));
            }else {
                if(response?.Body?.listSlots?.length > 0){
                    // thunkAPI.dispatch(goToPage('technicianPage'));
                    thunkAPI.dispatch( goToPage({ page: 'technicianPage', typePage: '' }));
                }else{
                    thunkAPI.dispatch( goToPage({ page: 'errorPage', typePage: 'NOT_POSSIBLE_SCHEDULE_TECHNICIAN_12_3' }));

                }
            }
        }else{
            thunkAPI.dispatch( goToPage({ page: 'errorPage', typePage: 'WRONG_REQUESTED_CANNOT_BE_PERFORMED_12_1_3' }));

        }

        return response?.Body;
    } catch (error) {
        thunkAPI.dispatch( goToPage({ page: 'errorPage', typePage: 'WRONG_REQUESTED_CANNOT_BE_PERFORMED_12_1_3' }));
        thunkAPI.dispatch(reportDWH({ actionType: 'Error Screen', status: 'Error', messageText: 'General Error', param1: 'TechnicianOrder' }));

        // thunkAPI.dispatch(setTypePage('WRONG_REQUESTED_CANNOT_BE_PERFORMED_12_1_3'));
        // thunkAPI.dispatch(goToPage('errorPage'));
    } finally {
        thunkAPI.dispatch(hideAppLoader());
    }
});

export const setTimeSlotAsync = createAsyncThunk('serviceAppointmentSchedulerBlock/setTimeSlotAsync', async (data, thunkAPI) => {
    try {
        thunkAPI.dispatch(showAppLoader());
        const state = thunkAPI.getState().serviceAppointmentSchedulerBlock;
        const selectedSubscriber = state.subscriber;

        const request = {
            ban: selectedSubscriber?.ban,
            consumerId: selectedSubscriber?.consumerId,
            startDate: state.technicianPage?.selectedTechnicianTime.startDate,
            endDate: state.technicianPage?.selectedTechnicianTime.endDate,
            address: {
                cityCode: selectedSubscriber?.address?.cityCode,
                streetCode: selectedSubscriber?.address?.streetCode,
                infrastructure: selectedSubscriber?.address?.infrastructure,
            }
        }

        const response = await ProviderManager.getProviderData('setWizardTechTimeSlot', request);

        if(response?.Body.isSuccess){
            thunkAPI.dispatch(reportDWH({ actionType: 'TechnicianOrder', status: 'Completed', messageText: 'Technician Order Completed' }));
            thunkAPI.dispatch(goToPage({page: 'technicianSuccessPage', typePage: ''}));
            thunkAPI.dispatch(reportDWH({ actionType: 'InternetFaultWizard Page', status: 'Completed', messageText: 'InternetFaultWizard Finished', param1: 'Technician Needed' }));
            thunkAPI.dispatch(createMemoAsync({memoType: 'AV61'} )); // 'תואם טכנאי ללקוח כתוצאה מחוסר סנכרון'
        }

        return response?.Body;
    } catch (error) {
        // thunkAPI.dispatch(setTypePage('WRONG_REQUESTED_CANNOT_BE_PERFORMED_12_1_3'));
        // thunkAPI.dispatch(goToPage('errorPage'));
        thunkAPI.dispatch( goToPage({ page: 'errorPage', typePage: 'WRONG_REQUESTED_CANNOT_BE_PERFORMED_12_1_3' }));
        thunkAPI.dispatch(reportDWH({ actionType: 'Error Screen', status: 'Error', messageText: 'General Error', param1: 'TechnicianOrder' }));

    } finally {
        thunkAPI.dispatch(hideAppLoader());
    }
});


//NOT IN USE
export const getDeliveryAsync = createAsyncThunk('serviceAppointmentSchedulerBlock/getDeliveryAsync', async (data, thunkAPI) => {
    try {
        thunkAPI.dispatch(showAppLoader());
        const serviceAppointmentScheduler = thunkAPI.getState().serviceAppointmentSchedulerBlock;
        const request = {
            ban: serviceAppointmentScheduler.subscriber.ban,
            blockId: serviceAppointmentScheduler.dataEpi.blockId
        };
        const result = await ProviderManager.getProviderData('routerActivationGetDelivery', request);
        thunkAPI.dispatch(hideAppLoader());

        if(result.Body.items?.length > 0){
            //thunkAPI.dispatch(createMemoAsync({memoType: ''} )); // 'ללקוח כבר קיים שליחות לספק כוח'
            thunkAPI.dispatch(goToPage({ page: 'errorPage', typePage: 'HAS_DELIVERY_POWER_SUPPLY' }))
        } else {
            //thunkAPI.dispatch(createMemoAsync({memoType: ''} )); // 'ללקוח לא קיים שליחות לספק כוח'
            thunkAPI.dispatch( goToPage({ page: 'serviceRequestMainPage', typePage: 'SELECT_DELIVERY_POWER_SUPPLY' }));
        }

        return result?.Body;

     } catch (error) {
        thunkAPI.dispatch( goToPage({ page: 'errorPage', typePage: 'GENERAL_ERROR' }));
        thunkAPI.dispatch(reportDWH({ actionType: 'Error Screen', status: 'Error', messageText: 'General Error', param1: 'GetDelivery' }));
    }
  });

  export const getDeliverySlotsAsync = createAsyncThunk('serviceAppointmentSchedulerBlock/getDeliverySlotsAsync', async (data, thunkAPI) => {
    try {
        thunkAPI.dispatch(showAppLoader());
        const serviceAppointmentScheduler = thunkAPI.getState().serviceAppointmentSchedulerBlock;
        const deliveryAddress = serviceAppointmentScheduler.delivery.address;
        const productId = serviceAppointmentScheduler.dataEpi.powerSupplySKU;

        const result = await ProviderManager.getProviderData('getDeliverySlots', [
          deliveryAddress.cityName,
          deliveryAddress.streetName,
          deliveryAddress.home,
          productId,
        ]);

        return result?.Body;
    } catch (error) {
    } finally {
        thunkAPI.dispatch(hideAppLoader());
    }
  });


  export const createDeliveryOrderAsync = createAsyncThunk('serviceAppointmentSchedulerBlock/createDeliveryOrderAsync', async (data, thunkAPI) => {
    try {
        thunkAPI.dispatch(showAppLoader());
        const serviceAppointmentScheduler = thunkAPI.getState().serviceAppointmentSchedulerBlock;
        const deliveryAddress = serviceAppointmentScheduler.delivery.address;
        const productId = serviceAppointmentScheduler.dataEpi.powerSupplySKU;
        const subscriberNumber = serviceAppointmentScheduler.subscriber.subscriberNo;
        const selectedDeliveryDate = serviceAppointmentScheduler.delivery.selectedDeliveryDate;
        const commCode = serviceAppointmentScheduler.commCode;

        const request = {
          ban: serviceAppointmentScheduler.subscriber.ban,
          subscriberNumber: subscriberNumber,
          productId: productId,
          commCode: commCode,
          deliveryDetails: {
            city: deliveryAddress.cityName,
            street: deliveryAddress.streetName,
            houseNum: deliveryAddress.home,
            apartment: deliveryAddress.apartment,
            receiverPhone: deliveryAddress.phoneNumber,
            startDate: selectedDeliveryDate.startDate,
            endDate: selectedDeliveryDate.endDate,
            round: selectedDeliveryDate.round,
            pickLocation: selectedDeliveryDate.pickLocation
          }
        }

        const result = await ProviderManager.getProviderData('routerActivationCreateDeliveryOrder', request );

        thunkAPI.dispatch(hideAppLoader());

        if(result.Body?.isSuccess){
            thunkAPI.dispatch(reportDWH({ actionType: 'Delivery Order', status: 'Completed', messageText: 'Delivery successfully ordered' }));
            thunkAPI.dispatch( goToPage({ page: 'deliverySuccessPage', typePage: null }));
        }
        else{
            thunkAPI.dispatch(reportDWH({ actionType: 'Error Screen', status: 'Error', messageText: 'General Error', param1: 'Delivery Order' }));
            thunkAPI.dispatch( goToPage({ page: 'errorPage', typePage: 'DELIVERY_POWER_SUPPLY_ERROR' }));
        }

        return result?.Body;
    } catch (error) {
        thunkAPI.dispatch(hideAppLoader());
    }
  });


